import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  promptFixIssueSchema,
  promptFixSchema,
} from "../prompt-helper/prompt-fix";

/** The changes the fix card offers for one issue; null when none could be written. */
export const draftShopperAgentStrategyGuidanceFix = {
  name: "draftShopperAgentStrategyGuidanceFix" as const,
  input: z.object({
    guidance: z.string(),
    mongoDiscountId: zExt.objectId().nullable(),
    issue: promptFixIssueSchema,
  }),
  output: z.object({ fix: promptFixSchema.nullable() }),
};
